import { FC, SVGAttributes } from 'react';

const SwipeRight: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.29293 7.29289C8.90241 7.68342 8.90241 8.31658 9.29293 8.70711L12.5858 12L9.29293 15.2929C8.90241 15.6834 8.90241 16.3166 9.29293 16.7071C9.68345 17.0976 10.3166 17.0976 10.7071 16.7071L14.5304 12.8839C15.0185 12.3957 15.0185 11.6043 14.5304 11.1161L10.7071 7.29289C10.3166 6.90237 9.68345 6.90237 9.29293 7.29289Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SwipeRight;
